import { render } from "./MatchesTable.vue?vue&type=template&id=15255069&scoped=true"
import script from "./MatchesTable.vue?vue&type=script&lang=js"
export * from "./MatchesTable.vue?vue&type=script&lang=js"

import "./MatchesTable.vue?vue&type=style&index=0&id=15255069&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15255069"]])

export default __exports__